import React, { useState, useEffect } from "react";

const Ourwork = () => {
  // Event photos data
  const eventPhotos = [
    "/events/event1.jpg",
    "/events/event2.jpg",
    "/events/event3.jpg",
    "/events/event4.jpg",
    "/events/event5.jpg",
  ];

  // Featured photos for slideshow
  const featuredPhotos = [
    "/Home1.jpeg",
    "/Home2.jpeg",
    "/Home3.jpeg",
    "/Home4.jpeg",

    "/Home5.jpeg",

  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % featuredPhotos.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [featuredPhotos.length]);

  return (
    <div className="py-12">
      <div className="container mx-auto px-4">
        {/* Our Moments Gallery */}
        <section className="mb-16 max-w-7xl mx-auto">
      <h2 className="text-3xl font-bold text-center mb-8 text-[#78371b]">
            Our Moments
          </h2>
          <div className="relative h-screen  overflow-hidden rounded-xl shadow-xl">
            {featuredPhotos.map((photo, index) => (
              <img
                key={index}
                src={photo}
                alt={`Featured ${index + 1}`}
                className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-1000 ${
                  index === currentSlide ? "opacity-100" : "opacity-0"
                }`}
              />
            ))}
            <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2">
              {featuredPhotos.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full ${
                    index === currentSlide ? "bg-white" : "bg-white/50"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </section>

  
      </div>
    </div>
  );
};

export default Ourwork;